var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-black-10 font-normal text-sm",attrs:{"test-id":"paginationDetails"}},[_vm._v(" Showing "+_vm._s(_vm.entryIndex)+" to "+_vm._s(_vm.endIndex)+" of "+_vm._s(_vm.totalCount)+" entries ")])
}
var staticRenderFns = []

export { render, staticRenderFns }